export class WordleError extends Error {
    code;
    constructor(code, message) {
        super(message ?? code);
        this.name = 'WordleError';
        this.code = code;
    }
}
export function isWordleError(err) {
    return err instanceof WordleError;
}
//# sourceMappingURL=errors.js.map